/**
 * useAuditFindingsQuery — Supplier S4 (audit findings library).
 *
 * GET /api/v1/supplier-audit-findings → NCRs + observations raised across
 * supplier audits, with severity / status / due-date / CAPA link.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '../../api/client';

export type FindingType = 'NCR' | 'OBSERVATION';
export type FindingSeverity = 'CRITICAL' | 'MAJOR' | 'MINOR';
export type FindingStatus = 'OPEN' | 'IN_PROGRESS' | 'CLOSED';

export interface AuditFinding {
  finding_id: string;
  supplier_id: string;
  supplier_name: string;
  audit_ref: string;
  finding_type: FindingType;
  severity: FindingSeverity;
  title: string;
  status: FindingStatus;
  raised_at_utc: string;
  due_at_utc: string | null;
  capa_ref: string | null;
  overdue: boolean;
}
export interface AuditFindingsResponse {
  items: AuditFinding[];
  summary: { total: number; open: number; overdue: number; critical: number; ncr: number };
}

export function useAuditFindingsQuery(): UseQueryResult<AuditFindingsResponse> {
  return useQuery<AuditFindingsResponse>({
    queryKey: ['suppliers', 'audit-findings'],
    queryFn: ({ signal }) => apiFetch<AuditFindingsResponse>('/api/v1/supplier-audit-findings', { signal }),
    staleTime: 60_000,
  });
}
